/* eslint-disable const-case/uppercase */
import { createContext } from "react"
const MYINFO_BASE_URL = window.myNtucConfig.myInfoBaseUrl
const CLIENT_ID = window.myNtucConfig.myInfoClientId
const ATTRIBUTES = `uinfin,name,sex,race,nationality,dob,email,mobileno,regadd,marital,edulevel,employment,occupation`
const PURPOSE = `NTUC Membership Form`
const STATE = Date.now() // timestamp

const REDIRECT_URL = window.myNtucConfig.myInfoCallbackUrl // myinfo only allows with this URL for dev. purposes

interface MyInfoData {
    user: {
        dob: string,
        email: string,
        gender: string,
        highestEducationLevel: string,
        maritalStatus: string,
        mobileNumber: string,
        name: string,
        nricFin: string,
        race: string,
        occupation: string,
        company: {
            code: string,
            name: string
        },
    }
    address: {
        blockHSENo: string,
        buildingName: string,
        floor: string,
        postalCode: string,
        street: string,
        unit: string
    }
}

const defaultMyInfoData: MyInfoData = {
    user: {
        dob: ``,
        email: ``,
        gender: ``,
        highestEducationLevel: ``,
        maritalStatus: ``,
        mobileNumber: ``,
        name: ``,
        nricFin: ``,
        race: ``,
        occupation: ``,
        company: {
            code: ``,
            name: ``,
        },
    },
    address: {
        blockHSENo: ``,
        buildingName: ``,
        floor: ``,
        postalCode: ``,
        street: ``,
        unit: ``,
    },
}

interface MyInfoContext {
    myInfoData: MyInfoData,
    setMyInfoData: any
}

const defaultMyInfoContext: MyInfoContext = {
    myInfoData: defaultMyInfoData,
    setMyInfoData: () => { return },
}

const MyInfoContextProvider = createContext(defaultMyInfoContext)

const MYINFO_AUTH_URL = `${MYINFO_BASE_URL}/authorise?client_id=${CLIENT_ID}&attributes=${ATTRIBUTES}&purpose=${PURPOSE}&state=${STATE}&redirect_uri=${REDIRECT_URL}`

export type { MyInfoData, MyInfoContext }
export { MYINFO_AUTH_URL, defaultMyInfoData, defaultMyInfoContext, MyInfoContextProvider }
